import { d as t } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var d = {
  name: "km",
  weekdays: "អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),
  months: "មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
  weekStart: 1,
  weekdaysShort: "អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),
  monthsShort: "មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
  weekdaysMin: "អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),
  ordinal: function(_) {
    return _;
  },
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd, D MMMM YYYY HH:mm"
  },
  relativeTime: {
    future: "%sទៀត",
    past: "%sមុន",
    s: "ប៉ុន្មានវិនាទី",
    m: "មួយនាទី",
    mm: "%d នាទី",
    h: "មួយម៉ោង",
    hh: "%d ម៉ោង",
    d: "មួយថ្ងៃ",
    dd: "%d ថ្ងៃ",
    M: "មួយខែ",
    MM: "%d ខែ",
    y: "មួយឆ្នាំ",
    yy: "%d ឆ្នាំ"
  }
};
t.locale(d, null, !0);
export {
  d as default
};
